






























































import Vue from 'vue';
import { FormFieldValidation, RouteHelpers, ObjectHelper } from '@/mixins';
import {
  ScriveTemplateSigningPartyFieldPlacementModel,
  ScriveTemplateSigningPartyFieldPlacementCreateUpdateModel,
  Dictionary,
  Configuration
} from '@/types';
import ScriceUpdateSingingPartyFieldPlacement from '@/components/configuration/scrive/ScriveUpdateSingingPartyFieldPlacement.vue';
import { ScriveConfigurationService } from '@/services/scrive/ScriveConfigurationService';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';

export default Vue.extend({
  name: 'ScriveEditSigningPartyFieldPlacement',
  mixins: [FormFieldValidation, RouteHelpers, ObjectHelper],
  data() {
    return {
      fieldPlacement: {} as ScriveTemplateSigningPartyFieldPlacementModel,
      isLoading: true,
      isSubmitting: false,
      serverValidationMessage: ''
    };
  },
  methods: {
    async getSigningPartyFieldPlacementAsync(this: any) {
      this.isLoading = true;
      try {
        this.fieldPlacement = await ScriveConfigurationService.getTemplateSigningPartyFieldPlacementConfigurationAsync(
          { templateSigningPartyFieldPlacementId: this.signingPartyFieldPlacementId }
        );
      } catch {
        this.$log('Error getting field placement configuration');
        this.fieldPlacement = {} as ScriveTemplateSigningPartyFieldPlacementModel;
      } finally {
        this.isLoading = false;
      }
    },
    async onfieldPlacementSavedAsync(this: any) {
      this.resetFormValidation();
      try {
        this.isSubmitting = true;
        const result = await ScriveConfigurationService.updateSigningPartyFieldPlacementAsync(
          this.signingPartyFieldPlacementId,
          {
            templateSigningPartyFieldId: this.signingPartyFieldId,
            pageNumber: this.fieldPlacement.pageNumber,
            relativeXPosition: this.fieldPlacement.relativeXPosition,
            relativeYPosition: this.fieldPlacement.relativeYPosition,
            relativeHeight: this.fieldPlacement.relativeHeight,
            relativeWidth: this.fieldPlacement.relativeWidth,
            relativeFontSize: this.fieldPlacement.relativeFontSize,
            pageNumberLocationType: this.fieldPlacement.pageNumberLocationType,
            tip: this.fieldPlacement.tip
          } as ScriveTemplateSigningPartyFieldPlacementCreateUpdateModel
        );

        if (result.hasNotification && !result.showToast) {
          this.serverValidationMessage = result.notification;
          this.submitIsLoading = false;
          return;
        }

        SnotifyConfiguration.showSuccess('Field placement updated successfully.');
        this.setApplicationDirty(false);

        this.navigateToEditSigningPartyField();
      } catch {
        this.$log('Error updating field placement');
      } finally {
        this.isSubmitting = false;
      }
    },
    navigateToEditSigningPartyField(this: any) {
      const param = {} as Dictionary<any>;
      param.documentTypeId = this.documentTypeId;
      param.templateId = this.templateId;
      param.signingPartyId = this.signingPartyId;
      param.id = this.signingPartyFieldId;
      this.$router.push({
        name: Configuration.Scrive.SigningPartyField.Edit.name,
        params: param
      });
    }
  },
  computed: {
    documentTypeId(): number {
      return Number(this.$route.params.documentTypeId);
    },
    templateId(): number {
      return Number(this.$route.params.templateId);
    },
    signingPartyId(): number {
      return Number(this.$route.params.signingPartyId);
    },
    signingPartyFieldId(): number {
      return Number(this.$route.params.signingPartyFieldId);
    },
    signingPartyFieldPlacementId(): number {
      return Number(this.$route.params.id);
    }
  },
  async mounted(this: any) {
    await this.getSigningPartyFieldPlacementAsync();
  },
  components: {
    ScriceUpdateSingingPartyFieldPlacement,
    LoadingSpinner
  }
});
